import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAccountPostingStatus implements BaseEnumType {
  private static allValues: EnumAccountPostingStatus[] = []; // make sure this is top-most
  
  public static inProgress = new EnumAccountPostingStatus(0, "InProgress", "enum_account_posting_status_in_progress");
  public static successful = new EnumAccountPostingStatus(1, "Successful", "enum_account_posting_status_successful");
  public static errored = new EnumAccountPostingStatus(2, "Errored", "enum_account_posting_status_errored");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAccountPostingStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isInProgress() { return this === EnumAccountPostingStatus.inProgress; }
  public isSuccessful() { return this === EnumAccountPostingStatus.successful; }
  public isErrored() { return this === EnumAccountPostingStatus.errored; }

  public static getValues(): readonly EnumAccountPostingStatus[] {
    return EnumAccountPostingStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumAccountPostingStatus[] {
    return EnumAccountPostingStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAccountPostingStatus {
    const found = EnumAccountPostingStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAccountPostingStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAccountPostingStatus): EnumAccountPostingStatus {
    const found = name ? EnumAccountPostingStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAccountPostingStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAccountPostingStatus>): boolean {
    return this.key === other?.key;
  }
}